import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { ParadiseOpsLogo, IconCheck } from '../components/Icons';
import api from '../api';

const ROLE_REDIRECTS = {
  chef: '/chef', gm: '/gm', bartender: '/bartender',
  supplies: '/supplies', restaurant_admin: '/admin', super_admin: '/admin', staff: '/chef',
};

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [restaurantName, setRestaurantName] = useState(null);

  useEffect(() => {
    api.get('/auth/tenant').then(r => setRestaurantName(r.data.name)).catch(() => {});
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const user = await login(email, password);
      navigate(ROLE_REDIRECTS[user.role] || '/');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="kairos-login-page">
      <div className="kairos-ambient">
        <div className="kairos-orb kairos-orb-teal" />
        <div className="kairos-orb kairos-orb-indigo" />
        <div className="kairos-grid" />
        <div className="kairos-vignette" />
      </div>

      <div className="kairos-login-wrap">
        <div className="kairos-card-glow" />
        <div className="kairos-card kairos-login-card">
          <div className="kairos-card-logo">
            <ParadiseOpsLogo size={64} variant="color" />
          </div>

          {restaurantName && (
            <div style={{ textAlign: 'center', marginBottom: 4 }}>
              <span style={{ fontSize: 13, fontWeight: 700, color: '#0D9488', letterSpacing: '0.04em' }}>{restaurantName}</span>
            </div>
          )}
          <div className="kairos-card-head">
            <div className="kairos-card-title">Welcome back</div>
            <div className="kairos-card-desc">{restaurantName ? `Sign in to ${restaurantName}` : 'Sign in to your account'}</div>
          </div>

          {error && (
            <div className="kairos-error">{error}</div>
          )}

          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div>
              <label className="kairos-label">Email</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                autoFocus
                placeholder="you@restaurant.com"
                className="kairos-input"
              />
            </div>
            <div>
              <label className="kairos-label">Password</label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                placeholder="••••••••"
                className="kairos-input"
              />
            </div>
            <button type="submit" disabled={loading} className="kairos-submit-btn">
              {loading ? 'Signing in...' : 'Sign in →'}
            </button>
          </form>

          <div className="kairos-trust">
            <span><IconCheck width={11} height={11} stroke="#0D9488" strokeWidth={2.5} /> Encrypted</span>
            <span><IconCheck width={11} height={11} stroke="#0D9488" strokeWidth={2.5} /> Role-based access</span>
          </div>
        </div>
      </div>
    </div>
  );
}
